/**
 * Make the typing impossible without disabling the input - useful for inputs
 * that are managed in a different way.
 *
 * ## Usage example
 * <pre>
 *   <input sw-disable-typing />
 * </pre>
 */
angular.module('coreModule').directive('swDisableTyping', () => ({
  restrict: 'A',
  link: function postLink(scope, element) {
    element.on('keypress', (e) => {
      e.preventDefault();
    });
  },
}));
